import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from '../common/Button';

export function TwoFAModal() {
  const { 
    isTwoFAModalOpen, 
    setIsTwoFAModalOpen, 
    twoFAQrCode, 
    twoFASecret, 
    verify2FA,
    showNotification 
  } = useUISettings();
  const [verificationCode, setVerificationCode] = useState('');
  const [step, setStep] = useState('qr');
  
  if (!isTwoFAModalOpen) return null;
  
  const handleVerify = () => {
    if (verificationCode.length === 6) {
      verify2FA(verificationCode);
      setVerificationCode('');
    } else {
      showNotification('Please enter a valid 6-digit code', 'error');
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Set Up Two-Factor Authentication</h3>
        
        {step === 'qr' && twoFAQrCode && (
          <>
            <p className="text-sm text-gray-600 mb-4">
              1. Scan this QR code with Google Authenticator or similar app
            </p>
            <div className="flex justify-center mb-4">
              <img src={twoFAQrCode} alt="2FA QR Code" className="border p-2 rounded-lg" />
            </div>
            <p className="text-sm text-gray-600 mb-4">
              2. If you can't scan, manually enter this secret: <br />
              <code className="bg-gray-100 p-1 rounded text-xs break-all">{twoFASecret}</code>
            </p>
            <Button
              onClick={() => setStep('verify')}
              variant="primary"
              fullWidth
            >
              Next: Verify Code
            </Button>
          </>
        )}
        
        {step === 'verify' && (
          <>
            <p className="text-sm text-gray-600 mb-4">
              Enter the 6-digit code from your authenticator app
            </p>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="000000"
              maxLength="6"
              className="w-full p-3 border border-gray-300 rounded-md mb-4 text-center text-2xl tracking-widest focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
            <div className="flex justify-end space-x-4">
              <Button onClick={() => setIsTwoFAModalOpen(false)} variant="secondary">
                Cancel
              </Button>
              <Button 
                onClick={handleVerify} 
                disabled={verificationCode.length !== 6}
                variant="success"
              >
                Verify & Enable
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}